import * as React from 'react';
const Play = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: props.size || '1em', height: props.size || '1em', viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "feather feather-play", ...props },
    React.createElement("polygon", { points: "5 3 19 12 5 21 5 3" })));
export default Play;
//# sourceMappingURL=Play.js.map